/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetEncountersPhotosParams,
  GetPhotosErrorResponse,
  GetPhotosResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getEncountersPhotos = (
  encounterId: number,
  params?: GetEncountersPhotosParams,
  signal?: AbortSignal,
) => {
  return api<GetPhotosResponse>({
    url: `/api/encounters/${encounterId}/photos`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetEncountersPhotosQueryKey = (
  encounterId?: number,
  params?: GetEncountersPhotosParams,
) => {
  return [`/api/encounters/${encounterId}/photos`, ...(params ? [params] : [])] as const;
};

export const getGetEncountersPhotosQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersPhotos>>,
  TError = GetPhotosErrorResponse,
>(
  encounterId: number,
  params?: GetEncountersPhotosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPhotos>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersPhotosQueryKey(encounterId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersPhotos>>> = ({ signal }) =>
    getEncountersPhotos(encounterId, params, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersPhotos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersPhotosQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersPhotos>>
>;
export type GetEncountersPhotosQueryError = GetPhotosErrorResponse;

export function useGetEncountersPhotos<
  TData = Awaited<ReturnType<typeof getEncountersPhotos>>,
  TError = GetPhotosErrorResponse,
>(
  encounterId: number,
  params: undefined | GetEncountersPhotosParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPhotos>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersPhotos>>,
          TError,
          Awaited<ReturnType<typeof getEncountersPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersPhotos<
  TData = Awaited<ReturnType<typeof getEncountersPhotos>>,
  TError = GetPhotosErrorResponse,
>(
  encounterId: number,
  params?: GetEncountersPhotosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPhotos>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersPhotos>>,
          TError,
          Awaited<ReturnType<typeof getEncountersPhotos>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersPhotos<
  TData = Awaited<ReturnType<typeof getEncountersPhotos>>,
  TError = GetPhotosErrorResponse,
>(
  encounterId: number,
  params?: GetEncountersPhotosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPhotos>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersPhotos<
  TData = Awaited<ReturnType<typeof getEncountersPhotos>>,
  TError = GetPhotosErrorResponse,
>(
  encounterId: number,
  params?: GetEncountersPhotosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersPhotos>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersPhotosQueryOptions(encounterId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
